import { render, staticRenderFns } from "./AdminResetAllSitesButton.vue?vue&type=template&id=560c9af4"
import script from "./AdminResetAllSitesButton.vue?vue&type=script&lang=js"
export * from "./AdminResetAllSitesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports